import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingHelpers } from 'src/infrastructure/helpers/RoutingHelpers';
import { Pages } from 'src/infrastructure/labels/pages';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css'],
  providers: [Router]
})
export class BaseComponent implements OnInit {

  protected _pageTitle: string = '';
  protected _error: string | null = '';
  protected _language = "bg";
  public hide = false;


  constructor() { }

  ngOnInit(): void {
  }

  public pageDetails() {
    return Pages.bg[this.pageTitle];
  }

  get error() {
    return this._error;
  }

  get pageTitle() {
    return this._pageTitle;
  }

  set pageTitle(title: string) {
    this._pageTitle = title;
  }
  
  back() {
    RoutingHelpers.instance.back();
  }

}
